import { FC, Fragment, MouseEvent, useRef, useState } from 'react';

import { ImagesApp } from '../../constants/images';
import { useEventContext } from '../../hooks/contexts/event.context';
import FanMember from '../IdentifyMember';
import CarouselItem from './CarouselItem';
import * as Style from './styles.carousel';

const CarouselDates: FC = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);

  const {
    dataCarousel,
    selectedIdDateCarousel : selectedId,
    singleDayDate,
    isFootball,
  } = useEventContext();
  const quantityItems = dataCarousel.length;

  const currentPosition = dataCarousel.findIndex(({ id }) => id === selectedId);

  const containerRef = useRef<HTMLDivElement>(null);

  const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    setIsDragging(true);
    const offsetLeft = containerRef.current?.offsetLeft ?? 0;
    setStartX(e.pageX - offsetLeft);
    if (containerRef.current) {
      containerRef.current.style.cursor = 'grabbing';
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    if (containerRef.current) {
      containerRef.current.style.cursor = 'grab';
    }
  };

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    if (!isDragging || !containerRef.current) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    containerRef.current.scrollLeft -= walk;
  };

  const moveLeft = () => {
    if (containerRef.current) {
      const scrollStep = -100;
      const newScrollPosition = containerRef.current.scrollLeft - scrollStep;
      containerRef.current.scrollLeft = Math.max(newScrollPosition, 0);
    }
  };

  const moveRight = () => {
    if (containerRef.current) {
      const scrollStep = -100;
      const maxScrollLeft =
        containerRef.current.scrollWidth - containerRef.current.clientWidth;
      const newScrollPosition = containerRef.current.scrollLeft + scrollStep;
      containerRef.current.scrollLeft = Math.min(
        newScrollPosition,
        maxScrollLeft
      );
    }
  };

  return (
    <Style.Container id="carousel-dates">
      {singleDayDate || isFootball ? (
        <Style.WrapperSingleDate id="wrapper-single-day-date">
          <Style.SingleDayDate id="single-day-date-content">
            <Style.TileDay id="tile-day">
              {singleDayDate.split(' - ')[0] || ''}
            </Style.TileDay>
            <Style.Subtitle id="subtitle-single-day-date">
              {(singleDayDate.split(' - ')[1] || '').toUpperCase()}
            </Style.Subtitle>
          </Style.SingleDayDate>
          {isFootball && <FanMember />}
        </Style.WrapperSingleDate>
      ) : (
        <Fragment>
          <Style.ArrowLeft
            $currentPosition={currentPosition}
            $quantityItems={quantityItems}
            onClick={moveRight}
            id="arrow-left"
          >
            <img src={ImagesApp.svg.arrowLeft} alt="Move Left" />
          </Style.ArrowLeft>
          <Style.ContainerItems
            id="container-items-dates"
            data-testid="container-items-dates"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            ref={containerRef}
          >
            {dataCarousel.map((item, i) => (
              <CarouselItem key={i} item={{ ...item, selectedId }} />
            ))}
          </Style.ContainerItems>
          <Style.ArrowRight
            $currentPosition={currentPosition}
            $quantityItems={quantityItems}
            onClick={moveLeft}
            id="arrow-right"
          >
            <img src={ImagesApp.svg.arrowRight} alt="Move Right" />
          </Style.ArrowRight>
        </Fragment>
      )}
    </Style.Container>
  );
};

export default CarouselDates;
